import React from 'react';

export default () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1.125rem"
      height="1.75rem"
      viewBox="0 0 16 25"
      version="1.1">
      <title>Group</title>
      <g
        id="Symbols"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd">
        <g
          id="Right-hand-vhc-tools"
          transform="translate(-23, -334)"
          fill="#54617A"
          fillRule="nonzero">
          <g id="Group" transform="translate(23, 334)">
            <path
              d="M7.65765766,4.56081081 C9.34684685,4.56081081 10.6981982,5.91216216 10.6981982,7.65765766 C10.6981982,9.34684685 9.34684685,10.6981982 7.65765766,10.6981982 C5.91216216,10.6981982 4.56081081,9.34684685 4.56081081,7.65765766 C4.56081081,5.91216216 5.91216216,4.56081081 7.65765766,4.56081081 Z M7.65765766,5.51801802 C6.47522523,5.51801802 5.51801802,6.47522523 5.51801802,7.65765766 C5.51801802,8.78378378 6.47522523,9.74099099 7.65765766,9.74099099 C8.78378378,9.74099099 9.74099099,8.78378378 9.74099099,7.65765766 C9.74099099,6.47522523 8.78378378,5.51801802 7.65765766,5.51801802 Z"
              id="Shape"
            />
            <path
              d="M10.472973,18.018018 C12.2184685,18.3558559 15.1463964,19.3130631 15.1463964,21.3400901 C15.1463964,24.2117117 9.74099099,25 7.65765766,25 C5.51801802,25 0.112612613,24.2117117 0.112612613,21.3400901 C0.112612613,19.3693694 2.98423423,18.3558559 4.78603604,18.018018 C2.59009009,14.1891892 0,9.51576577 0,7.65765766 C0,3.43468468 3.43468468,0 7.65765766,0 C11.8243243,0 15.259009,3.43468468 15.259009,7.65765766 C15.259009,9.51576577 12.6689189,14.1891892 10.472973,18.018018 Z M5.29279279,18.8626126 C4.05405405,19.0878378 1.06981982,19.8761261 1.06981982,21.3400901 C1.06981982,23.4797297 6.19369369,24.0427928 7.65765766,24.0427928 C9.06531532,24.0427928 14.1891892,23.4797297 14.1891892,21.3400901 C14.1891892,19.8198198 11.0923423,19.0878378 9.96621622,18.8626126 C9.23423423,20.1576577 8.50225225,21.3400901 8.0518018,22.1846847 C7.88288288,22.4662162 7.37612613,22.4662162 7.20720721,22.1846847 C6.75675676,21.3400901 6.08108108,20.213964 5.29279279,18.8626126 Z M7.65765766,0.957207207 C3.94144144,0.957207207 0.957207207,3.94144144 0.957207207,7.65765766 C0.957207207,10.0225225 5.85585586,17.9617117 7.65765766,21.0022523 C9.40315315,17.9054054 14.3018018,9.96621622 14.3018018,7.65765766 C14.3018018,3.94144144 11.3175676,0.957207207 7.65765766,0.957207207 Z"
              id="Shape"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};
